import { Companies, felsineaEnvMapper, sirmanEnvMapper } from 'corporate-types';
export const isLocalTest = () => {
    const env = multiCompanySafeEnv({ key: 'NEXT_PUBLIC_ENV', fallbackValue: '' });
    return env === 'local-test';
};
/**
 * @param {MultiCompanySafeEnvData} data - The object that containst all the data needed to retrieve a specific env variable
 * @property {string} data.key - Identifies an env variable's name
 * @property {string} [data.locale] - for example: 'en-GB', 'en-US', 'it-IT'
 * @property {string} [data.fallbackValue] - returned if no env variable match the provided key
 * @throws {Error} - if no value is found and {@link fallbackValue} is not provided
 * @return The correct endpoint retrieved from environment variables, given a key and a locale, considering the company of the running environment
 */
export const multiCompanySafeEnv = (data) => {
    const { key, fallbackValue, locale } = data;
    const envVar = localizeEnvVariableByCompany(key, locale);
    const result = envVar || fallbackValue;
    if (result === undefined) {
        throw new Error(`Missing key in in .env file: ${key}`);
    }
    return result;
};
const localizeEnvVariableByCompany = (key, locale) => {
    if (!locale) {
        return process.env[key];
    }
    switch (process.env.NEXT_PUBLIC_COMPANY) {
        case Companies.FELSINEA:
            return mapEnvKeyGivenALocale(felsineaEnvMapper, key, locale);
        case Companies.SIRMAN:
        default:
            return mapEnvKeyGivenALocale(sirmanEnvMapper, key, locale);
    }
};
const mapEnvKeyGivenALocale = (mapper, key, locale) => {
    const mappedValue = mapper.get(`${key}_${locale}`);
    if (!mappedValue) {
        return process.env[key];
    }
    return process.env[`${key}_${mappedValue}`];
};
//# sourceMappingURL=env-utils.js.map